import { render, staticRenderFns } from "./EditVdNameDialog.vue?vue&type=template&id=6b002df2&scoped=true"
import script from "./EditVdNameDialog.vue?vue&type=script&lang=ts"
export * from "./EditVdNameDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditVdNameDialog.vue?vue&type=style&index=0&id=6b002df2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b002df2",
  null
  
)

export default component.exports